import { render } from "./RouteTabsComponent.vue?vue&type=template&id=e2758938"
import script from "./RouteTabsComponent.vue?vue&type=script&lang=js"
export * from "./RouteTabsComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__